import React from 'react';

export default function BookingPageHero({ title, subtitle }) {
	return (
		<header className="packages-hero booking-page-hero" role="banner">
			<div className="container text-center">
				<h1 className="text-white text-larger mb-2">{title}</h1>
				{subtitle && (
					<p className="text-white mb-0 packages-hero__sub booking-page-hero__sub">
						{subtitle}
					</p>
				)}
			</div>
		</header>
	);
}
